export const URL_DigitalPayment = (`${process.env.REACT_APP_HOST}/digitalPaymentsScheduling`)